// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1Lzy7","title-content":"style_title-content__1ISBy","btn":"style_btn__3tgxa"};